/**
 * 内容安全管理页面
 *
 * 路由: /admin/safe
 * Tab: dashboard / logs / profile / ban / settings
 */

import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AdminLayout from '../components/layout/AdminLayout';
import { RiskDashboard } from '../components/safeguard/RiskDashboard';
import { AuditLogTable } from '../components/safeguard/AuditLogTable';
import { UserProfilePanel } from '../components/safeguard/UserProfilePanel';
import { BanManagement } from '../components/safeguard/BanManagement';
import { SafeguardSettingsPanel } from '../components/safeguard/SafeguardSettings';

const TABS = [
  { id: 'dashboard', label: '风险监控' },
  { id: 'logs', label: '审核日志' },
  { id: 'profile', label: '用户画像' },
  { id: 'ban', label: '封禁管理' },
  { id: 'settings', label: '安全配置' },
];

const SafeguardAdminPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'dashboard';

  const handleTabChange = (tabId: string) => {
    setSearchParams({ tab: tabId });
  };

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <RiskDashboard autoRefresh />;
      case 'logs':
        return <AuditLogTable />;
      case 'profile':
        return <UserProfilePanel />;
      case 'ban':
        return <BanManagement />;
      case 'settings':
        return <SafeguardSettingsPanel />;
      default:
        return <RiskDashboard autoRefresh />;
    }
  };

  return (
    <AdminLayout>
      <div className="h-full flex flex-col">
        {/* 标题 */}
        <div className="flex-shrink-0 px-6 py-4 border-b border-gray-100">
          <h1 className="text-xl font-bold text-gray-900">内容安全</h1>
          <p className="text-sm text-gray-500 mt-1">监控内容风险，管理用户封禁，配置安全策略</p>
        </div>

        {/* Tab 导航 */}
        <div className="flex-shrink-0 px-6 border-b border-gray-100">
          <nav className="flex gap-6">
            {TABS.map(tab => (
              <button
                key={tab.id}
                onClick={() => handleTabChange(tab.id)}
                className={`py-3 text-sm font-medium border-b-2 transition-colors ${
                  activeTab === tab.id
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {/* 内容区 */}
        <div className="flex-1 overflow-y-auto p-6">
          {renderContent()}
        </div>
      </div>
    </AdminLayout>
  );
};

export default SafeguardAdminPage;
